
export const typeProtocol = {
  computed: {
    isDTT: function() {
      return this.teachingMethod == 1;
    },

    isSimple: function() {
      return this.teachingMethod == 2;
    },

    isMand: function() {
      return this.teachingMethod == 3;
    },

    isUSD: function () {
      return this.teachingMethod == 4;
    },

    isChain: function () {
      return this.teachingMethod == 5;
    },

    isShaping(){
      return this.teachingMethod == 6
    },

    isPecs(){
      return this.teachingMethod == 7
    },

    isPecsWithoutDiscrimination(){
      return this.teachingMethod == 8
    },

    isPecsWithDiscrimination(){
      return this.teachingMethod == 9
    },

    isPecsWithItems(){
      return this.teachingMethod == 10
    }

  }
}


// WEBPACK FOOTER //
// ./src/common/mixins/typeProtocol.js